<template>
  <div>
    <h1 class="title is-4">
      グラフ(お試し版)
    </h1>
    <div class="columns">
      <div class="column is-narrow">
        <label class="label">期間</label>
        <b-datepicker
          v-model="duration"
          range
          @input="getGraphData"
        />
      </div>
    </div>
    <apexchart type="line" height="350" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
export default {
  name: "Graph",
  data() {
    return {
      duration: [],

      series: [],
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: '',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            format: 'M/d',
          }
        },
        annotations: {
          yaxis: [{
            y: 0
          }]
        }
      },
    }
  },
  created() {
    this.getGraphData()
  },
  methods: {
    getGraphData() {
      let params = {
        duration: this.duration
      }
      this.$http.get('/graphs', {params: params}).then(response => {
        this.series = response.data.graph_data

      })
    },
  }
}
</script>

<style scoped>

</style>